import React from 'react';
import {NavLink} from 'fluxible-router';
import Store from '../../models/Store';
import AppStoreBadges from '../AppStoreBadges';
import styles from './index.sass';
import banquetFooterLogo from './images/banquet_footer_logo_3x.png';
import GrayBanquetLogoPng from './images/banquet_gray_2x.png';
import GrayBanquetLogoSvg from './images/banquet_gray.svg';
import {
  ShareButtons,
  ShareCounts,
  generateShareIcon
} from 'react-share';

const PlayStoreLink = 'https://play.google.com/store/apps/details?id=com.delectable.market&hl=en';
const AppStoreLink = 'https://itunes.apple.com/us/app/banquet-shop-top-wine-stores/id1058119446?mt=8';

class Footer extends React.Component {
  static propTypes = {
    store: React.PropTypes.instanceOf(Store),
    hideOnMobile: React.PropTypes.bool
  };

  static defaultProps = {
    hideOnMobile: false
  };

  static contextTypes = {
    getUserAgent  : React.PropTypes.func
  };

  renderAddress(address) {
    if(!address) {return null;}
    return (
      <li>
        <span>{address.addr1} {address.addr2}</span>
        <br/>
        <span>{address.city}, {address.state} {address.zip_code}</span>
      </li>
    );
  }

  renderHours(hours) {
    if(!hours) {return null;}
    return(
      <li>
        <span>Hours:</span>
        <br/>
        <span dangerouslySetInnerHTML={{__html: hours.replace(/\n/g, '<br/>')}} />
      </li>
    );
  }

  renderPhone(store) {
    if(!store.phone_pretty || !store.phone_href_format) {return null;}
    return (
      <li>
        <a href={`tel:${store.phone_href_format}`}>{store.phone_pretty}</a>
      </li>
    );
  }

  render() {
    let { store } = this.props;
    let hideOnMobileClass = this.props.hideOnMobile ? styles.hideOnMobile : '';
    const {
      FacebookShareButton,
      GooglePlusShareButton,
      TwitterShareButton
    } = ShareButtons;
    const FacebookIcon = generateShareIcon('facebook');
    const GooglePlusIcon = generateShareIcon('google');
    const TwitterIcon = generateShareIcon('twitter');
    let year = new Date().getFullYear();

    if(!store) {
      return (
        <div className={`${styles.footer} ${styles.marketingFooter} ${hideOnMobileClass}`}>
          <div className={styles.inner}>
            <div className={styles.left}>
              <img className={styles.logo} src={GrayBanquetLogoPng} srcSet={GrayBanquetLogoSvg} />
              <div>
                <a href="https://delectable.com/terms">Terms of Use</a><span className={styles.middot}>&middot;</span><a href="https://delectable.com/privacy">Privacy</a>
              </div>
              <p className={styles.copyright}>©{year} Vinous Group LLC</p>
            </div>
            <div className={styles.right}>
              <ul className={styles.links}>
                <li><NavLink href="/">Home</NavLink></li>
                <li><NavLink href="/sell-on-banquet">Sell on Banquet</NavLink></li>
                <li><NavLink href="/customers">Shop</NavLink></li>
              </ul>
              <AppStoreBadges className={styles.appStoreBadges} appStoreLink={AppStoreLink} playStoreLink={PlayStoreLink} />
            </div>
          </div>
        </div>
      );
    }
    let location = store.hours ? (
      <div className={styles.column}>
        <p className={styles.columnHeader}>Location</p>
        <ul>
          {this.renderAddress(store.address)}
          {store.address ? <li><br /></li> : null}
          {this.renderHours(store.hours)}
        </ul>
      </div>
    ) : null;
    let contact = (store.contact_email || (store.phone_pretty && store.phone_href_format)) ? (
      <div className={styles.column}>
        <p className={styles.columnHeader}>Contact</p>
        <ul>
          {this.renderPhone(store)}
          {store.contact_email ? <li><a href={`mail:${store.contact_email}`}>{store.contact_email}</a></li> : null}
          <li>
            <FacebookShareButton
              picture={store.logo_photo_hash.url}
              url={store.url}
              title={store.name}
              description={store.marketing_message}
              className={styles.socialButton}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>
            <GooglePlusShareButton
              url={store.url}
              className={styles.socialButton}>
              <GooglePlusIcon size={32} round />
            </GooglePlusShareButton>
            <TwitterShareButton
              url={store.url}
              title={store.name}
              className={styles.socialButton}>
              <TwitterIcon size={32} round />
            </TwitterShareButton>
          </li>
        </ul>
      </div>
    ) : null;
    return (
      <div className={`${styles.storeFooter} ${hideOnMobileClass}`}>
        <div className={styles.inner}>
          <div className={styles.column}>
            <p className={styles.columnHeader}>Info</p>
            <ul>
              <li><NavLink routeName="storeLandingPage">Home</NavLink></li>
              <li><NavLink routeName="storeAboutPage">About</NavLink></li>
              <li><NavLink routeName="collections">Collections</NavLink></li>
              {store.refund_policy ? <li><NavLink routeName="refundPolicy">Return & Refund Policy</NavLink></li> : null}
              {store.terms_of_service ? <li><NavLink routeName="termsOfService">Terms of Service</NavLink></li> : null}
              <li>
                <div className={styles.weAcceptFooter}>
                  <span className={styles.weAcceptMessage}>We accept</span>
                  <span className={styles.ccAmericanExpress} />
                  <span className={styles.ccMasterCard} />
                  <span className={styles.ccDiscover} />
                  <span className={styles.ccVisa} />
                </div>
              </li>
            </ul>
          </div>
          {location}
          {contact}
        </div>
        <p className={styles.disclaimer}>WARNING: DRINKING DISTILLED SPIRITS, BEER, COOLERS, WINE AND OTHER ALCOHOLIC BEVERAGES MAY INCREASE CANCER RISK, AND, DURING PREGNANCY, CAN CAUSE BIRTH DEFECTS.</p>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// banquet/components/Footer/index.js